import Reveal from "@/components/Reveal";

// Curatorial wall-text — like vinyl lettering between rooms in a gallery.
export default function ManifestoChapter({ number, title, body, signoff }) {
  return (
    <section className="panel panel--chapter" data-testid={`chapter-${number}`}>
      <div className="chapter__inner">
        <Reveal as="p" className="chapter__text" delay={0.1}>
          {body}
        </Reveal>
        {signoff && (
          <Reveal as="p" className="chapter__signoff" delay={0.18} data-testid={`chapter-signoff-${number}`}>
            {signoff}
          </Reveal>
        )}
      </div>
    </section>
  );
}
